import React, { useState } from "react";
import "./Header.css";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const NAV_ITEMS = [
  { to: "/", label: "முகப்பு", end: true },
  { to: "/about", label: "எங்களை பற்றி" },
  { to: "/founder", label: "நிறுவனர்" },
  { to: "/news", label: "செய்திகள்" },
  { to: "/events", label: "நிகழ்வுகள்" },
  { to: "/erode-bookfair", label: "ஈரோடு புத்தகத் திருவிழா 2026" },
  { to: "/contact", label: "தொடர்பிக்க" }
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="navbar-container">
      <header>
        <div className="header-top">
          <NavLink to="/" className="brand" onClick={closeMenu}>
            <img src="/images/mainlogo.png" alt="" className="brand-logo" />
            <span className="brand-title">மக்கள் சிந்தனைப் பேரவை</span>
          </NavLink>

          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "மெனுவை மூடு" : "மெனுவைத் திற"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <nav className={`navbar ${isMenuOpen ? "open" : ""}`}>
          <ul className="nav-list">
            {NAV_ITEMS.map((item) => (
              <li className="nav-item" key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>
    </div>
  );
};

export default Header;